export const FORCE_EXP_KEY = 'force-exp-'
export const TEST_AUDIENCE = 'test-audience'
export const VARIATION = 'variation'

export const WT_CHECKOUT_CW = 'wt-checkout-cw'
export const VIEWPAGE_PLAGIARISM_EXPORT = 'viewpage-plagiarism-export'
export const UPLOAD_WIDGET_FEATURE = 'upload-widget'
export const UPLOAD_WIDGET_DEMO_FEATURE = 'upload-widget-demo'
export const IMPROVED_BOOK_JOURNAL_SEARCH = 'improved-search'
export const SITE_PERFORMANCE_FEATURE = 'site-performance'
export const OWL_EXPERIMENT_KEY = 'owl-citation-widget-gam-z'
export const CW_PRICE_TEST = 'cw-price-test'
export const CROSSREF_RESULT_COUNT = 'crossref-result-count'
export const AA_TEST = 'aa'
export const AUTOCITE_V0_RIO_EVENTS = 'autocite-v0-rio-events'
export const UPDATE_AUTOCITE_API = 'update-autocite-api'
export const UPDATE_MESSAGING_FEATURE_BM = 'update-messaging-bm'
export const UPDATE_MESSAGING_FEATURE_EB = 'update-messaging-eb'
export const UPDATE_MESSAGING_FEATURE_CTFM = 'update-messaging-ctfm'
export const UPDATE_MESSAGING_FEATURE_CM = 'update-messaging-cm'
export const ENABLE_PARAPHRASER = 'enable-paraphraser'
export const UPDATE_AUTH_MODAL_EB = 'eb-update-auth-modal'
export const EB_AD_UNLOCK_MODAL = 'eb-ad-unlock-modal'
export const SEARCH_WIDGET_EXP = 'search-widget-experiment'
export const GUEST_CITATION_VALIDITY_CM = 'guest-citation-validity-cm'
export const GUEST_CITATION_VALIDITY_EB = 'guest-citation-validity-eb'
export const AD_UNLOCK_MODAL_EB = 'ad_unlock_modal_eb'
export const AD_UNLOCK_MODAL_CM = 'ad_unlock_modal_cm'

// low ad test
export const LOW_AD_EB = 'low-ad-eb'
export const LOW_AD_CM = 'low-ad-cm'
export const LOW_AD_CONTROL_CELL = 'low-ads-m-control'
export const LOW_AD_VARIATION1 = 'low-ads-m-test'
export const LOW_AD_VARIATION2 = 'low-ads-n-test'
export const LOW_AD_VARIATION3 = 'low-ads-o-test'
export const LOW_AD_DEFAULT_CM = 'low-ad-cm-control'
export const LOW_AD_DEFAULT_EB = 'low-ad-eb-control'
export const LOW_AD_VARIATIONS = {
  control: LOW_AD_CONTROL_CELL,
  variation_1: LOW_AD_VARIATION1,
  variation_2: LOW_AD_VARIATION2,
  variation_3: LOW_AD_VARIATION3,
}

export const STOP_AD_RELOAD_FEATURE_KEY = 'stop-ad-reload'

// Pricing Experiment Easybib and Citation Machine Q4 2023
export const Q423_PRICING_EXP_EB = 'q423-pricing-exp-eb'
export const Q423_PRICING_TEST_FEATURE_EB = 'q423_pricing_test_eb'
export const Q423_PRICING_EXP_CM = 'q423-pricing-exp-cm'
export const Q423_PRICING_TEST_FEATURE_CM = 'q423_pricing_test_cm'

export const PRICING_EXP_VARIATIONS = {
  control: 'BASE',
  low: 'CHEGG_Q423_LOW',
  mid: 'CHEGG_Q423_MID',
  high: 'CHEGG_Q423_HIGH',
}

export interface PricingExpVariables {
  pricingJson: {
    price: string
    pricingExperiment: string
    basePrice: number
  }
}

// interstitial ad test
export const INTERSTITIAL_AD_EB = 'interstitial-ad-eb-feature'
export const INTERSTITIAL_AD_CTFM = 'interstitial-ad-ctfm-feature'
export const INTERSTITIAL_AD_CTFM_EB_CONTROL_CELL = 'copy-interstitial-9-control'
export const INTERSTITIAL_AD_CTFM_EB_TEST_CELL = 'copy-interstitial-9-test'
export const STOP_AD_RELOAD_CM = 'stop-ad-reload'
export const STOP_AD_RELOAD_CM_TEST_CELL_VARIABLE = 'reload-copy-22-test'
export const STOP_AD_RELOAD_CM_TEST_CELL_VARIABLE_REGEX = /reload-copy-\d{2}-test/
export const STOP_AD_RELOAD_CM_CONTROL_CELL_VARIABLE = 'reload-copy-22-control'

export const INTERSTITIAL_AD_CTFM_EB_VARIATIONS = {
  control: INTERSTITIAL_AD_CTFM_EB_CONTROL_CELL,
  test: INTERSTITIAL_AD_CTFM_EB_TEST_CELL,
}

export const STOP_AD_RELOAD_CM_VARIATIONS_VARIABLES = {
  control: STOP_AD_RELOAD_CM_CONTROL_CELL_VARIABLE,
  test: STOP_AD_RELOAD_CM_TEST_CELL_VARIABLE,
}
